import { motion } from 'framer-motion'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ColumnsTable, HeaderActions, IMoneyAccount, ISell } from 'safe'
import Empty from '../../../components/Display/Empty'
import Table from '../../../components/Display/Table'
import { ColumnItemWrapper } from '../../../components/General/ColumnItemWrapper'
import { RootState } from '../../../redux/store'
import {
  formatAmount,
  formatPipe,
  formatter,
  getSellStatus,
  getYearMonthAndDay,
} from '../../../utils/utils'
import ViewWithTabs, {
  DataTabView,
} from '../../../components/Display/ViewWithTabs'
import Modal from '../../../components/Display/Modal'
import { fetchSells } from '../../../redux/actions/sells'
import { useLocalStorageState } from '../../../hooks/useLocalStorageState'
import { useForm } from 'react-hook-form'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Select from '../../../components/Inputs/Select'
import Button from '../../../components/General/Button'
import InputText from '../../../components/Inputs/InputText'
import SelectOfCategories from '../../../components/Inputs/SelectOfCategories'
import InputNumber from '../../../components/Inputs/InputNumber'
import Switch from '../../../components/Inputs/Switch'
import Tooltip from '../../../components/Display/Tooltip'
import InputCheck from '../../../components/Inputs/InputCheck'
import CurrencyInput from '../../../components/Inputs/CurrencyInput'

const ZellePaymentForm: React.FC<WalletFormProp> = ({
  onCancel,
  onSubmitProp,
  total,
  debt,
  rate,
}) => {
  const form = useForm({
    defaultValues: {
      amount: 0,
    },
  })

  const [isManual, setIsManual] = useState<boolean>(false)

  const accounts = useSelector(
    (state: RootState) => state.acct.accounts
  ).filter((v) => v.accountVisible)

  const onSubmit = (values): void => {
    onSubmitProp({
      ...values,
      isManual,
      amount: +formatPipe(values.amount, true),
    })
  }

  const usdDebt = useMemo(
    () =>
      formatPipe(
        (+debt / +(rate.find((r) => r.id === '1')?.rate || 1)).toFixed(2)
      ),
    [debt, rate]
  )

  useEffect(() => {
    form.setValue('amount', `$ ${usdDebt}`)
  }, [])

  return (
    <>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        // id={id}
        onSubmit={(values) => onSubmit(values)}
      >
        <div className="col-span-12" style={{ fontWeight: 500 }}>
          Zelle
        </div>
        {/* <div className="col-span-12">DEUDA: Bs {formatPipe(total+"")}</div>
        <div className="col-span-12">DEUDA EN USD (REF.): { usdDebt }</div>
        <div className="col-span-3">Nombre</div> */}

        <FormItem name="name" classes="col-span-12">
          <InputText small label="Nombre" />
        </FormItem>

        {/* <div className="col-span-3">Monto</div> */}
        <FormItem
          name="amount"
          classes="col-span-12"
          defaultValue={''}
          rules={{
            required: 'Es necesario el monto',
            // pattern: { value: /^\d+(\.\d{2})?$/, message: 'Monto inválido' },
          }}
        >
          {/* <InputText small maxLength={80} /> */}
          {/* <InputNumber addDecimals={true} label='Monto' /> */}
          <CurrencyInput addDecimals={true} mask="$ num" label="Monto" />
        </FormItem>

        <div className="col-span-12 flex flex-row items-center mt-2">
          <div className="mr-3">Verificación Manual</div>
          <FormItem name="isManual" defaultValue={false}>
            <Tooltip title={'Solo se permiten pagos por bofa o chase'}>
              {/* <Switch  forForm={true} value={isManual} onChange={(v) => setIsManual(v)} /> */}
              <InputCheck
                value={isManual}
                onChange={(v) => {
                  // console.log("V", v.target.checked)
                  setIsManual(v.target.checked)
                }}
              />
            </Tooltip>
          </FormItem>
        </div>

        <div className="col-span-12 h-full flex flex-row mt-2">
          <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={() => onCancel()}>
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit">
              Continuar
            </Button>
          </div>
        </div>
      </Form>
    </>
  )
}

interface WalletFormProp {
  onSubmitProp: Function
  onCancel: Function
  total: number
  debt: number | string
  rate?: any
}

interface options {
  value: string
  text: string
}

enum valuesEnum {
  national = 'nationalTransfer',
  mobile = 'mobilePayment',
}

export default ZellePaymentForm
